module.exports = __webpack_public_path__ + "img/ssh-access.c31c66b.svg";